import React from "react";
import { Box, Typography } from "@mui/material";

export function ErrorPage6() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        bgcolor: "grey.100",
        textAlign: "center",
        p: 4,
      }}
    >
      <Typography variant="h1" sx={{ fontWeight: 700, mb: 3, color: "text.primary" }}>
        Oops...
      </Typography>
      <Typography variant="h5" sx={{ color: "text.secondary" }}>
        Looks like something went wrong.
        <br />
        We&apos;re working on it
      </Typography>
    </Box>
  );
}
